import { h } from 'preact';

export default (props) => {
	return (
		<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 27 16" role="img" {...props}>
			<path d="M23.3943 6.22368C23.3376 3.58074 21.1798 1.44933 18.511 1.44933C17.6026 1.44933 16.7792 1.70512 16.041 2.13141C14.7918 0.824167 13.0599 0 11.1009 0C8.0347 0 5.4511 2.01771 4.59937 4.83119C2.01577 5.11537 0 7.33204 0 10.0034C0 12.9021 2.35651 15.2609 5.25237 15.2609H22.429C24.9558 15.2609 27 13.2148 27 10.6854C26.9716 8.49716 25.4385 6.67838 23.3943 6.22368Z" />
		</svg>
	);
};